export default "__VITE_ASSET__pIF_U1G1__"